module.exports = __webpack_public_path__ + "img/c104fe4a9be6dbb2951aa8f38e2ca79e.png";